import React from "react";
import { Star } from "lucide-react";
import { REVIEWS } from "../lib/constants";

function Card({ r, i }) {
    return (
        <div
            className="shrink-0 w-[320px] md:w-[380px] mx-4 bg-white border border-sand rounded-2xl p-7 shadow-sm flex flex-col"
            data-testid={`review-card-${i}`}
        >
            <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, idx) => (
                    <Star key={idx} className="h-4 w-4 fill-[#E8B769] text-[#E8B769]" />
                ))}
            </div>
            <p className="text-stone-700 text-base leading-relaxed flex-1">"{r.text}"</p>
            <div className="mt-6 pt-5 border-t border-sand flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-coffee-100 text-coffee-800 flex items-center justify-center font-serif text-lg">
                    {r.name[0]}
                </div>
                <div>
                    <div className="text-sm font-medium text-coffee-900">{r.name}</div>
                    <div className="text-xs text-stone-500">Verified · Google review</div>
                </div>
            </div>
        </div>
    );
}

export default function Reviews() {
    const doubled = [...REVIEWS, ...REVIEWS];
    return (
        <section id="reviews" className="relative py-24 md:py-32 bg-cream overflow-hidden" data-testid="reviews-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10 mb-14">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
                    <div className="lg:col-span-7">
                        <p className="text-xs tracking-[0.3em] uppercase text-forest-700 mb-5">What guests say</p>
                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-coffee-900 leading-tight">
                            Stories from the <span className="italic text-forest-700">guestbook.</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-4 lg:col-start-9 flex items-center gap-4">
                        <div className="flex">
                            {Array.from({ length: 5 }).map((_, i) => (
                                <Star key={i} className="h-5 w-5 fill-[#E8B769] text-[#E8B769]" />
                            ))}
                        </div>
                        <div>
                            <div className="text-2xl font-serif text-coffee-900">4.7 / 5</div>
                            <div className="text-xs text-stone-500 tracking-wider uppercase">From 396+ Google reviews</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative" data-testid="reviews-marquee">
                <div className="marquee-track py-4">
                    {doubled.map((r, i) => (
                        <Card key={i} r={r} i={i} />
                    ))}
                </div>
                <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-cream to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-cream to-transparent" />
            </div>
        </section>
    );
}
